import { Table } from "antd";
import { useState } from "react";

const TableMed = ({ data, columns, onPaginationChange, loading }) => {
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [pageSize, setPageSize] = useState(10); // Track the page size

  // Call onPaginationChange prop whenever page or pageSize changes
  const handlePaginationChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    if (onPaginationChange) {
      onPaginationChange(page, size); // Pass pagination to parent
    }
  };

  return (
    <Table
      loading={loading}
      size="middle"
      rowKey="id"
      columns={columns}
      scroll={{ x: "max-content" }}
      dataSource={data}
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: data?.length,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
        onChange: handlePaginationChange, // Update pagination with the handler
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
      }}
    />
  );
};

export default TableMed;
